import React, { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import Negocio from '../../../functions/logic/Negocio'
import DynamicTable from '../../../components/DataTables/DynamicTable'
import Spiner from '../../../components/Spiner'
import FormModal from '../../../components/General/FormModal'
import ConfirmModal from '../../../components/ConfirmModal'
import { useSnackbar } from 'notistack'

export default function OrdenesCompraPagadas() {
    const [spiner, setSpiner] = useState(false)
    const [isOpenModalform, setIsOpenModalForm] = useState(false)
    const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false)
    const [dataServiceForm, setDataServiceForm] = useState([])
    const [bodegaId, setBodegaId] = useState(0)
    const [saveType, setSaveType] = useState('I')
    const [headerModal, setheaderModal] = useState('I')
    const param = useParams()
    const { enqueueSnackbar } = useSnackbar()
    const userToken = localStorage.getItem('userToken')
    const [data, setdata] = useState([])
    const [totalRows, setTotalRows] = useState(0)

    const columns = ['Orden', 'Fecha', 'Subtotal', 'Subtotal2', 'Descuento', 'Iva', 'Total', 'Estado orden', 'Estado Pago']

    const getOrdenesPendientes = useCallback(async (page, perPage, param, ordenId, search) => {
        setSpiner(true)
        global.MENU_MODULE_SELECT = 'negocio'
        const response = await Negocio.getOrdenesLogic(page, perPage, userToken, param.moduleId, global.ORDENES_PAGADAS, ordenId, search)
        localStorage.setItem('param', JSON.stringify(param.moduleId))
        if (!response.error) {
            setdata(response["responseTableMapper"])
            setTotalRows(response.total_records)
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
        setSpiner(false)
    }, [enqueueSnackbar, userToken])

    useEffect(() => {
        getOrdenesPendientes(1, 5, param, 0, 'no')
    }, [param, getOrdenesPendientes])

    const handleEdit = (bodega) => {
        setheaderModal("Editar Bodega");
        setSaveType("E");
        setBodegaId(bodega.id)

        const selectedBodega = data.find(item => item.id === bodega.id);

        if (selectedBodega) {
            setDataServiceForm(selectedBodega)
        }

        setIsOpenModalForm(true)
    };


    const handledSave = async (event) => {
        setSpiner(true)
        event.preventDefault()
        const response = await Negocio.saveBodegaLogic(userToken, param.moduleId, event.target, bodegaId, saveType)

        if (!response.error) {
            setSpiner(false)
            setIsOpenModalForm(false)
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
            setTimeout(function () {
                getOrdenesPendientes(1, 5, param, 0, 'no')
            }, global.DELAY)
        } else {
            setSpiner(false)
            enqueueSnackbar(response.message, {
                variant: "error",
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
    }

    const handledConfirmDelete = async (e) => {
        setSpiner(true)
        const response = await Negocio.deleteProductLogic(userToken, param.moduleId, bodegaId)
        setSpiner(false)
        setIsOpenModalConfirm(false)
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        })
        setTimeout(function () {
            getOrdenesPendientes(1, 5, param, 0, 'no')
        }, global.DELAY)
    }

    const handleCloseModal = () => {
        setIsOpenModalForm(false)
        setIsOpenModalConfirm(false)
        cleanStorage()
    }

    const cleanStorage = () => {
        localStorage.removeItem('nombre')
        localStorage.removeItem('ubicacion')
        localStorage.removeItem('tipo')
        localStorage.removeItem('estado')
        localStorage.removeItem('codigo')
    }

    const handlePageChange = (page, perPage) => {
        setSpiner(true)
        getOrdenesPendientes(page, perPage, param, 0, 'no')
        setSpiner(false)
    }

    const handleSearch = (item) => {
        if (item === "") {
            getOrdenesPendientes(1, 5, param, 0, 'no')
        } else {
            setSpiner(true)
            getOrdenesPendientes(1, 1, param, 0, item)
            setSpiner(false)
        }
    }

    return (
        <>
            <Spiner opt={spiner} />
            <FormModal
                isOpen={isOpenModalform}
                handleCloseModal={handleCloseModal}
                header={headerModal}
                button={'Guardar'}
                formData={dataServiceForm}
                handledSave={handledSave}
                opt={'bodegaForm'}
                modalWith={'sm'}
            />
            <ConfirmModal
                isOpen={isOpenModalConfirm}
                handleCloseModal={handleCloseModal}
                header={'Desactivar producto su producto no será visible'}
                body={'Estás seguro de desactivar el producto'}
                button={'Desactivar'}
                formData={dataServiceForm}
                handledConfirmDelete={handledConfirmDelete}
            />
            <div className="content-wrapper">
                <section className="content-header">
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="project-actions text-right">
                                            <h4>Ordenes con pago confirmado</h4>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <DynamicTable
                                                columns={columns}
                                                data={data}
                                                headerText=""
                                                onEdit={handleEdit}
                                                onSearch={handleSearch}
                                                onPageChange={handlePageChange}
                                                totalRows={totalRows}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </>
    )
}




